import * as React from "react"

type LogoSize = "sm" | "md" | "lg" | "xl"

const sizeMap: Record<LogoSize, { width: number; height: number }> = {
  sm: { width: 60, height: 60 },
  md: { width: 100, height: 100 },
  lg: { width: 240, height: 240 },
  xl: { width: 320, height: 320 },
}

interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  size?: LogoSize
}

export function Logo({ size = "md", style, ...props }: LogoProps) {
  const dimensions = sizeMap[size]
  return (
    <img
      src="/images/logo.svg"
      alt="Tempered Talent"
      style={{ ...dimensions, ...style }}
      {...props}
    />
  )
}
